// import 'core-js/stable'
import CoreuiVue from '@coreui/vue/src';
import router from './router';
import {hasAuthor, isAuthorized, roles} from './security';
import {iconsSet as icons} from './assets/icons/icons';
import helper from './helper';
import Notifications from 'vue-notifications';
import miniToastr from 'mini-toastr';
import store from './store';
import App from './App';
import Vue from 'vue';
import babelpolyfill from 'babel-polyfill';
import {connect, checkConnect, sendMessageSocket, disConnectSocket} from './socket/index';
import {ColorPicker, ColorPanel} from '../public/static/js/colorpicker.js';
import VueCurrencyInput from 'vue-currency-input';
import * as VueGoogleMaps from "vue2-google-maps";
import { SUPPILER_ICON } from './constant';

// Set the favicon dynamically
const link = document.createElement('link');
link.rel = 'icon';
link.href = SUPPILER_ICON; // Use the environment variable
document.head.appendChild(link);

const plugin = {
  install() {
    Vue.prototype.$helper = helper
    Vue.prototype.$hasAuthor = hasAuthor
    Vue.prototype.$isAuthorized = isAuthorized
    Vue.prototype.$authRoles = roles()
    Vue.prototype.$disConnectSocket = disConnectSocket
    Vue.prototype.$checkConnectSocket = checkConnect
    Vue.prototype.$sendMessageSocket = sendMessageSocket
    Vue.prototype.$connectSocket = connect
  }
}

function toast({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const toastTypes = {
  success: 'success',
  error: 'error',
  warn: 'warn'
}
const options = {
  success: toast,
  error: toast,
  warn: toast
}

const pluginOptions = {
  globalOptions: { currency: 'VND'}
}

miniToastr.init({types: toastTypes})
Vue.use(VueCurrencyInput, pluginOptions);
Vue.use(Notifications, options);
Vue.use(CoreuiVue);
Vue.use(plugin);
Vue.use(ColorPicker);
Vue.use(ColorPanel);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyC0-j4k5cRJtVu7b5CGwFnRQtRkP1DoYaA",
    libraries: "places",
    region: 'VI',
    language: 'vi',
  }
});

new Vue({
  el: '#app',
  router,
  store,
  //CIcon component documentation: https://coreui.io/vue/docs/components/icon
  icons,
  babelpolyfill,
  template: '<App/>',
  components: {
    App,
  },
})
